<template>
    <section>
        <Hero/>
        <PageContent/>
    </section>
</template>

<script setup>
import Hero from "@/views/ServicesComponents/Hero";
import PageContent from "@/views/ServicesComponents/PageContent";
</script>
